import { useOrganization } from '@/contexts/OrganizationContext';
import { useRole } from '@/hooks/use-role';
import { isInSetupMode } from '@/features/onboarding/lib/setup-mode';

/**
 * Is the current user in setup mode (BLU-1376)? Reads the org context and the
 * profile already in memory: no query, no effect. Fails open (see setup-mode.ts).
 */
export function useSetupMode(): boolean {
  const { organization } = useOrganization();
  const { isPlatformAdmin } = useRole();
  return isInSetupMode(organization, isPlatformAdmin());
}
